module.exports = __webpack_public_path__ + "static/media/bolso (34).4ec9987a.jpg";